import { forwardRef } from "react";

import { MantineStyleProp, Text, TextProps } from "@mantine/core";

export interface TextWrapperProps extends TextProps {
  variant?: keyof typeof textVariants;
  style?: MantineStyleProp;
  children: React.ReactNode;
  id?: string;
}

const textVariants = {
  primary: { base: 400 },
  bold: { base: 600 },
  default: { base: 400 },
  label: { base: 500 },
  semibold: { base: 500 },
  "anchor-bold": { base: 700 },
} as const;

// Function components cannot be given refs. Use forwardRef to pass the ref to the underlying Text component.
const TextWrapper = forwardRef<HTMLDivElement, TextWrapperProps>(
  ({ variant = "default", style, children, id, ...mantineProps }, ref) => {
    return (
      <Text
        ref={ref}
        fw={textVariants[variant]}
        style={{ wordWrap: "break-word", ...style }}
        {...mantineProps}
        {...(id ? { id } : {})}
      >
        {children}
      </Text>
    );
  },
);

TextWrapper.displayName = "TextWrapper";

export default TextWrapper;
